import { gql } from "@apollo/client";

export const GetApexStatesQuery = gql`
query GetApexStates($where: misc_apex_data_bool_exp = {}) {
  misc_apex_data(where: $where) {
    id
    state
    emp_no
    name
    designation
    hq
  }
}
`